// src/App.jsx
import React from "react";
import { useEffect, useState } from "react";
import img1 from "../Assets/1.png"



function Biography() {


    return (
        <div className="min-h-screen bg-white">
            {/* <h2 className="text-3xl font-bold p-4">Biography:</h2> */}

            <div className="flex flex-col items-center  min-h-screen p-4 w-full">
                {/* Profile Image */}
                <img
                    src={img1}
                    alt="img1"
                    className="w-46 h-64 rounded shadow mb-4"
                />

                {/* Profile Info */}
                <div className="max-w-2xl text-center text-black ">
                    {/* Name */}
                    <p className="font-bold text-xl mb-2 font-serif">
                        DR. NAVIN KUMAR
                    </p>

                    {/* Email */}
                    <p className=" text-lg mb-4 font-serif">
                        nkumar@iitrpr.ac.in
                    </p>

                    {/* Title */}
                    <h5 className="text-base mb-4 font-serif">
                        PROFESSOR & HEAD <br />
                        Department of Mechanical Engineering and Biomedical Engineering <br />
                        Indian Institute of Technology Ropar
                    </h5>

                </div>
                <div className="w-full text-black space-y-2 mt-4 font-serif text-xl">
                    <p>PhD 2006, Mechanical Engineering, Indian Institute of Technology Delhi, India</p>
                    <p>M.Tech. (Mechanical Engineering), Indian Institute of Technology Kharagpur</p>
                    <p>B.Tech. (Hons) (Mechanical Engineering), Aligarh Muslim University, Aligarh</p>
                    <div className="w-full h-1 bg-cyan"></div>
                    <p><b>Research Areas:</b> Hard (Bone) and Soft Tissue Mechanics, Biomechanics, Biomedical Devices, Finite Element based Modelling, Smart Structures and Materials, Fault Diagnosis and Condition Monitoring, Active Vibration Control.</p>
                    <div className="w-full h-1 bg-cyan"></div>
                    <p><b>Biography:</b><br/><br/>Dr. Navin Kumar is a Professor in the Department of Mechanical Engineering and Biomedical Engineering at IIT Ropar. Prior to joining IIT Ropar, he was working as a Research Scientist at Stevens Institute of Technology, New Jersey, USA. He has completed masters in Mechanical Engineering from IIT Kharagpur and Ph.D. in Mechanical Engineering from IIT Delhi. Dr. Navin Kumar's research interests are related to vibration and noise, fault diagnosis and condition monitoring, Biomechanics of hard and soft tissue, biomedical instrumentation, smart structures and materials.</p>
                   
                    <div className="w-full h-1 bg-cyan"></div>
                    <p><b>Work Experience:</b><br/><br/>
                      <li>Professor, Indian Institute of Technology Ropar, Nov 2021 - Present</li>
                      <li>Associate Professor, Indian Institute of Technology Ropar, December 2015- Nov 2021</li>
                      <li>Assistant Professor, Indian Institute of Technology Ropar, India, January 2010- December 2015</li>
                      <li>Research Scientist, Stevens Institute of Technology, New Jersey, USA, January 2007-December 2009</li>
                      <li>Engineer (Good Year Ltd) 1997-1998.</li>
                    </p>

                    <div className="w-full h-1 bg-cyan"></div>
                    <p><b>Institute Level Responsibilities:</b><br/><br/>
                      <li>Dean (Research and Development) ( 2021-2023 )</li>
                      <li>PG Coordinator (equivalent to Dean, PG program) IIT Ropar (2014-2015)</li>
                      <li>Member IIT Ropar Senate (2014-2018, 2021-till date)</li>
                      <li>Faculty-In charge -Student Activity Centre (SAC) ( 2010-2015).</li>
                      <li>Program officer- NCC, IIT Ropar, 2010-2018.</li>
                      <li>Program officer- NSS, IIT Ropar, 2010-2018.</li>
                      <li>Chairman, Institute Transport committee (2013-2014).</li>
                      <li>Chairman, IIT Ropar safety committee (2021-Till date).</li>
                      <li>Member, Hindi Committee (2021-Till date).</li>
                      <li>Mech Egg Dept faculty short listing committee (2015-2020).</li>
                      <li>Academic Committee for post graduate Studies (RPEC) member at Indian Institute of Technology Ropar (2012-2015).</li>
                      <li>Faculty member IIT Ropar student alumni association.</li>
                      <li>Faculty advisor Institute student magazine (The Horizon).</li>
                      <li>Member of several institute committees.</li>
                      <li>Faculty adviser of Institute ENACTUS (En-entrepreneur Act-action Us-we all) team.</li>
                    </p>

                    <div className="w-full h-1 bg-cyan text-xl"></div>
                    <p><b>Departmental Responsibilities:</b><br/><br/>
                      <li>HOD, Mech Engineering Dept ( Jan 2025 – Present )</li>
                      <li>HOD, Mech Engineering Dept (March 2015 – May 2018)</li>
                      <li>Organized institute’s first Industry academia conclave ( IAC 2015).</li>
                      <li>M.Tech. (Mechanical Engineering) program started in 2015-2016.</li>
                      <li>Departmental representative of the Academic Committee for Research Program Evaluation (RPEC), IIT Ropar (2011- 2014).</li>
                      <li>Member academic committee for Under Graduates ACUG (2014- 2015 ).</li>
                      <li>Faculty Advisor for 2018 ME batch MTech students, IIT Ropar (2018-2020).</li>
                      <li>Member Academic Committee for Research Program Evaluation (RPEC), IIT Ropar (2011- 2014).</li>
                      <li>Member of several departmental committees.</li>
                    </p>
                    
                    </div>
            </div>




        </div>
    );
}

export default Biography;
